// import ServiceBase from './ServiceBase';
import AuthService from './AuthService'
import REST_API from './API_Routes'
import Tickets from './Tickets'
import Notifications from './Notifications'
import Customer from './Customer'
import Asset from './Asset'
import Invoice from './Invoice'
import Appointment from './Appointment'

const TicketsService = new Tickets(REST_API.TICKET_LIST)
const NotificationsService = new Notifications(REST_API.NOTIFICATIONS)
// const TicketsService = new ServiceBase(REST_API.GROUP);
const CustomerService = new Customer(REST_API.CUSTOMER)
const AssetService = new Asset(REST_API.ASSET)
const InvoiceService = new Invoice(REST_API.INVOICE)
const AppointmentService = new Appointment(REST_API.APPOINTMENT)

export {
  AuthService,
  TicketsService,
  NotificationsService,
  CustomerService,
  AssetService,
  InvoiceService,
  AppointmentService,
}
